import Avvir from "avvir";
import { AvvirThunk } from "../make_eventful_action";
import tosAccepted, { TosAcceptedEvent } from "../../events/auth_events/tos_accepted";
import getUser from "../../services/getters/base_getters/get_user";

type DispatchedEvents =
  | TosAcceptedEvent;

const acceptTos = (id: number): AvvirThunk<Promise<void>, DispatchedEvents> => {
  return (dispatch, getState) => {
    const user = getUser(getState(), {});
    return Avvir.api.tos.accept(id, user).then((body) => {
        return dispatch(tosAccepted(id));
      });
  };
};

export default acceptTos;
